import React from "react";
import {Outlet, useLocation} from "react-router-dom";
import Header from './Header';
import Interested from './Interested';
import Footer from './Footer';

const Layout = ({topRef, menuOpen, toggleMenu, handleMenuClick}) => {
  
  const location = useLocation();
  
  return(
    <>
        <Header topRef={topRef} menuOpen={menuOpen} toggleMenu={toggleMenu} handleMenuClick={handleMenuClick} />
        <Outlet />
        {location.pathname != "/contact" && <Interested handleMenuClick={handleMenuClick} />}
        <Footer handleMenuClick={handleMenuClick} />
    </>
  );
}

export default Layout;